module.exports = __webpack_public_path__ + "img/Pelletheizung-Pro-Kontra.7e3dc24.webp";